import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './LoginModal.css';

export default function LoginModal({ open, onClose, onOpenRegister, onOpenForgot }) {
  const [form, setForm] = useState({ email: '', password: '' });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const nav = useNavigate();
  const { login } = useAuth();

  if (!open) return null;

  const submit = async (event) => {
    event.preventDefault();
    setError('');
    try {
      const user = await login(form);
      onClose();
      const rolePath = user.role === 'admin' ? '/dashboard/admin' : '/dashboard/member';
      nav(rolePath);
    } catch (err) {
      setError(err.message || 'Login failed.');
    }
  };

  return (
    <div className="login-modal" role="dialog" aria-modal="true">
      <div className="login-overlay" onClick={onClose} aria-hidden="true" />
      <div className="login-popup">
        <button className="login-close" onClick={onClose} aria-label="Close login">
          ×
        </button>
        <div className="login-popup-brand">
          <p className="login-popup-eyebrow">Welcome back</p>
          <h2>Sign in to SFACO-CTG</h2>
          <p>Continue your alumni journey with events, mentors, and chapters.</p>
        </div>

        <form className="login-popup-form" onSubmit={submit}>
          <label>
            Email address
            <input
              type="email"
              placeholder="you@alumni.org"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              required
            />
          </label>
          <label>
            Password
            <div className="login-popup-password-wrap">
              <input
                type={showPassword ? 'text' : 'password'}
                placeholder="••••••••"
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                required
              />
              <button
                type="button"
                className="login-popup-password-toggle"
                onClick={() => setShowPassword((prev) => !prev)}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
              >
                {showPassword ? 'Hide' : 'Show'}
              </button>
            </div>
          </label>

          {error && <p className="login-popup-error">{error}</p>}

          <button type="submit" className="login-popup-submit">Sign in</button>
          <button
            type="button"
            className="login-popup-link"
            onClick={() => {
              onClose();
              if (onOpenForgot) onOpenForgot();
            }}
          >
            Forgot password?
          </button>
        </form>

        <div className="login-popup-footer">
          <span>New here?</span>
          <Link to="/register" onClick={onClose}>Create an account</Link>
          <button
            type="button"
            className="login-popup-link"
            onClick={() => {
              onClose();
              if (onOpenRegister) onOpenRegister();
            }}
          >
            Open register popup
          </button>
          <Link to="/login" onClick={onClose}>Full login page</Link>
        </div>
      </div>
    </div>
  );
}
